module.exports = __webpack_public_path__ + "img/7277b24bc052568f60cd10321ee6c657.png";